import { createSlice } from '@reduxjs/toolkit';
import { dispatch } from 'src/redux/store';
import axios from 'src/utils/axios';

const initialState = {
  isMenuLoading: false,
  error: null,
  menus: null,
};

const slice = createSlice({
  name: 'menu',
  initialState,
  reducers: {
    // START LOADING
    startMenuLoading(state) {
      state.isMenuLoading = true;
    },
    // HAS ERROR
    hasError(state, action) {
      state.isMenuLoading = false;
      state.error = action.payload;
    },
    // SET MENU
    setMenus(state, action) {
      state.isMenuLoading = false;
      state.menus = action.payload;
    },
  },
});

// Reducer
export default slice.reducer;

// Actions
export const { startMenuLoading, hasError } = slice.actions;

// ----------------------------------------------------------------------

export function getMenu() {
  return async () => {
    dispatch(slice.actions.startMenuLoading());
    try {
      const response = await axios.get(`/admin/auth/permitted_menu`);
      dispatch(slice.actions.setMenus(response.data));
    } catch (error) {
      dispatch(slice.actions.hasError(error));
    }
  };
}
